var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGamepadUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    t: 1719107868413,
    className: "icon",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    "p-id": 37982,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 16,
    height: 16,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M384 86.016v234.016l128 128 128-128V86.016h-256z m86.016 84h84v86.016h-84V170.016zM86.016 384v256h234.016l128-128-128-128H86.016zM704 384l-128 128 128 128h234.016v-256H704z m-192 192l-128 128v234.016h256V704l-128-128z",
    "p-id": 37983,
    fill: "#333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGamepadUp);
export default __webpack_public_path__ + "static/media/gamepad-up.09b5085ae71bb210f9e4f9cced6b717e.svg";
export { ForwardRef as ReactComponent };